const columns = [
  {
    title: '数据源名称',
    key: 'soc_name',
  },
  {
    title: 'ip地址',
    key: 'soc_ip',
  },
  {
    title: '端口号',
    key: 'soc_port',
  },
  {
    title: '协议类型',
    key: 'protocol_type',
    render:(h,{columns,row,index}) =>{
      let target_host = '';
      switch(row.protocol_type){
        case 1:
          target_host = 'JDBC';
          break;
        case 2:
          target_host = 'PLT_FTP';
          break;
        case 3:
          target_host = 'AS400_FTP';
          break;
        case 4:
          target_host = 'SCP_FTP';
          break;
        case 5:
          target_host = 'SSH';
          break;
        case 6:
          target_host = 'AS400_PGM';
          break;
        case 7:
          target_host = 'AS400_CL';
          break;
        case 8:
          target_host = 'ESB';
        case 9:
          target_host = 'JDBC';
          break;
        case 10:
          target_host = 'PLT_FTP';
          break;
        case 11:
          target_host = 'AS400_FTP';
          break;
        case 12:
          target_host = 'SCP_FTP';
          break;
        case 13:
          target_host = 'SSH';
          break;
        case 14:
          target_host = 'AS400_PGM';
          break;
        case 15:
          target_host = 'AS400_CL';
          break;
        case 16:
          target_host = 'ESB';
          break;
        case 17:
          target_host = 'ESB';
          break;
        default:
          target_host = '--'
      }
      return h("span",target_host);
    }
  },
  {
    title: '目标主机登录用户名',
    key: 'remote_uname',
  },
  {
    title: '操作',
    slot: 'iconfont',
    iconClass: [
      {
        name: 'ys-iconbianji', code: '编辑', status: 1, Pname: 'resources_data_source_tab_edit'},
      { name: 'ys-iconlajitongbeifen', code: '删除', status: 1, Pname: 'resources_data_source_tab_delate'}
    ]
  },
]

export default columns